import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api/admin';

export interface EmailSendRequest {
  estimateId: number;
  to: string;
  cc?: string;
  bcc?: string;
  subject?: string;
  senderEmail?: string;
  senderName?: string;
  customMessage?: string;
  includeCustomMessage?: boolean;
  pdfBuffer: string; // base64 encoded
  companyInfo: {
    name: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    phone: string;
    email: string;
    website?: string;
  };
}

export interface EmailConfig {
  host: string;
  port: number;
  secure: boolean;
  auth: {
    user: string;
    pass: string;
  };
}

export class EmailService {
  private static getAuthHeaders() {
    const tokens = localStorage.getItem('cnf_auth_tokens');
    if (tokens) {
      const parsed = JSON.parse(tokens);
      return {
        Authorization: `Bearer ${parsed.accessToken}`,
      };
    }
    return {};
  }

  static async sendEstimateEmail(data: EmailSendRequest): Promise<{ success: boolean; message: string }> {
    try {
      const response = await axios.post(`${API_BASE_URL}/email/send-estimate`, data, {
        headers: this.getAuthHeaders(),
      });
      return response.data;
    } catch (error: any) {
      console.error('Send email error:', error);
      throw new Error(
        error.response?.data?.message || 'Failed to send email'
      );
    }
  }

  static async configureEmail(config: EmailConfig): Promise<{ success: boolean; message: string }> {
    try {
      const response = await axios.post(`${API_BASE_URL}/email/configure`, config, {
        headers: this.getAuthHeaders(),
      });
      return response.data;
    } catch (error: any) {
      console.error('Configure email error:', error);
      throw new Error(
        error.response?.data?.message || 'Failed to configure email'
      );
    }
  }

  static async testConnection(): Promise<{ success: boolean; message: string }> {
    try {
      const response = await axios.post(`${API_BASE_URL}/email/test-connection`, {}, {
        headers: this.getAuthHeaders(),
      });
      return response.data;
    } catch (error: any) {
      console.error('Test connection error:', error);
      throw new Error(
        error.response?.data?.message || 'Failed to test email connection'
      );
    }
  }

  static async getEmailConfig(): Promise<{
    host: string;
    port: number;
    secure: boolean;
    hasAuth: boolean;
  }> {
    try {
      const response = await axios.get(`${API_BASE_URL}/email/config`, {
        headers: this.getAuthHeaders(),
      });
      return response.data;
    } catch (error: any) {
      console.error('Get email config error:', error);
      throw new Error(
        error.response?.data?.message || 'Failed to get email configuration'
      );
    }
  }
}